/**
 * Icones do modulo do fluxo (#484909): o cartao do modulo na timeline do
 * portal do cliente. Lista fechada, a mesma do backend
 * (FluxoEstruturaService::ICONES_MODULO): todos registrados em
 * assets/icons/index.js (icone fora do registro quebra a pagina).
 */
export const ICONES_MODULO: Array<[string, string]> = [
    ['cil-basket', 'Produtos e cadastro'],
    ['cil-cart', 'Marketplace e vendas'],
    ['cil-truck', 'Logística e frete'],
    ['cil-wallet', 'Financeiro'],
    ['cil-dollar', 'Fiscal e preços'],
    ['cil-credit-card', 'Pagamentos'],
    ['cil-bank', 'Banco e conciliação'],
    ['cil-brush', 'Visual e site'],
    ['cil-globe-alt', 'Marketing e SEO'],
    ['cil-speech', 'Atendimento e SAC'],
    ['cil-envelope-closed', 'E-mail'],
    ['cil-bell', 'Notificações'],
    ['cil-puzzle', 'Integrações'],
    ['cil-swap-vertical', 'Migração'],
    ['cil-people', 'Usuários e permissões'],
    ['cil-briefcase', 'Gestão e governança'],
    ['cil-settings', 'Configuração e operação'],
    ['cil-applications-settings', 'Automação e IA'],
    ['cil-education', 'Treinamento'],
    ['cil-check-circle', 'Go-live'],
    ['cil-history', 'Pós-go-live'],
    ['cil-calendar', 'Agenda'],
    ['cil-description', 'Documentos'],
    ['cil-task', 'Checklist'],
    ['cil-location-pin', 'Lojas e localidades'],
    ['cil-home', 'Institucional'],
    ['cil-chart-pie', 'Relatórios e dados'],
    ['cil-shield-alt', 'Segurança'],
    ['cil-star', 'Destaque'],
    ['cil-layers', 'Geral'],
];

const PERMITIDOS = new Set(ICONES_MODULO.map(([icone]) => icone));

// Sem icone escolhido, pelo nome. Ordem importa: o primeiro que casar vale
// (ex.: "Pós-Go-Live" antes de "Go-Live", "IA de Atendimento" antes de "SAC").
const PELO_NOME: Array<[RegExp, string]> = [
    [/p[oó]s.?go.?live|acompanhamento/i, 'cil-history'],
    [/go.?live|lan[cç]amento|publica/i, 'cil-check-circle'],
    [/\bia\b|automa|intelig/i, 'cil-applications-settings'],
    [/cadastr|produto|cat[aá]logo/i, 'cil-basket'],
    [/site|layout|visual|design|tema/i, 'cil-brush'],
    [/log[ií]stic|frete|entrega|estoque/i, 'cil-truck'],
    [/marketplace|canais|canal/i, 'cil-cart'],
    [/vendas|pedido|checkout/i, 'cil-basket'],
    [/financ|pagamento|fatur|cobran/i, 'cil-wallet'],
    [/fiscal|imposto|tribut|pre[cç]o/i, 'cil-dollar'],
    [/treinamento|capacita/i, 'cil-education'],
    [/migra/i, 'cil-swap-vertical'],
    [/integra|api\b|erp/i, 'cil-puzzle'],
    [/sac|crm|atendimento|whats/i, 'cil-speech'],
    [/marketing|seo|campanha/i, 'cil-globe-alt'],
    [/usu[aá]rio|permiss|acesso/i, 'cil-people'],
    [/governan|gest[aã]o|projeto/i, 'cil-briefcase'],
    [/opera[cç]|configura/i, 'cil-settings'],
    [/relat[oó]rio|dados|dashboard|an[aá]lise/i, 'cil-chart-pie'],
];

/** Icone que o modulo usa: o escolhido; sem ele, o do nome; senao o generico. */
export const iconeDoModulo = (nome: string, escolhido?: string | null) => {
    if (escolhido && PERMITIDOS.has(escolhido)) return escolhido;
    return PELO_NOME.find(([padrao]) => padrao.test(nome))?.[1] ?? 'cil-layers';
};
